import React from "react";
import { useToasts } from "../hooks/useToasts";
import "./Toasts.css";

const Toasts = () => {
  const { toasts, removeToast } = useToasts();

  return (
    <div className="toasts-root">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`toasts-toast toasts-toast-${t.type}`}
          onClick={() => removeToast(t.id)}
        >
          {t.message}
        </div>
      ))}
    </div>
  );
};

export default Toasts;
